/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snapshot_History_Restore_Confirm_TitleInputs */



/**
* | output |
* | --- |
* | "Restore this version?" |
*
* @param {Snapshot_History_Restore_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snapshot_history_restore_confirm_title = /** @type {((inputs?: Snapshot_History_Restore_Confirm_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snapshot_History_Restore_Confirm_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Restore this version?")
	if (locale === "de") return /** @type {LocalizedString} */ ("Restore this version?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Restore this version?")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Restore this version?")
	if (locale === "es") return /** @type {LocalizedString} */ ("Restore this version?")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Restore this version?")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Restore this version?")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Restore this version?")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Restore this version?")
	return /** @type {LocalizedString} */ ("Restore this version?")
});